// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"26e5fa5f","171":"92e5cba7","186":"9b6eae90","374":"dc9c31e4","429":"5e7ac4aa","453":"97234524","507":"f6e54b9f","512":"f0f90113","695":"59f87c78","780":"0db84d92"}[chunkId] + ".chunk.js";
};